import React from 'react';
import ConfirmDialog from 'Shared/ConfirmDialog';

const DeleteCartModal = ({
  open, onClose, onConfirm, loading,
}) => (
  <ConfirmDialog
    open={open}
    variant="delete"
    title="Supprimer ce panier"
    message="Cette action supprimera définitivement ce panier. Souhaitez-vous continuer ?"
    onClose={onClose}
    onConfirm={onConfirm}
    loading={loading}
  />
);

export default DeleteCartModal;
